import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../firebase';
import { useNavigate } from 'react-router-dom';

const ResetPasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('이메일 주소를 입력해주세요.');
      return;
    }

    try {
      setError('');
      setLoading(true);
      
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
    } catch (error: any) {
      console.error('비밀번호 재설정 오류:', error);
      let errorMessage = '비밀번호 재설정 중 오류가 발생했습니다.';
      
      switch (error.code) {
        case 'auth/invalid-email':
          errorMessage = '유효하지 않은 이메일 주소입니다.';
          break;
        case 'auth/user-not-found':
          errorMessage = '등록되지 않은 이메일입니다.';
          break;
        case 'auth/too-many-requests':
          errorMessage = '너무 많은 요청이 있었습니다. 잠시 후 다시 시도해주세요.';
          break;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="h-full flex flex-col">
      <div className="space-y-6">
        <div>
          <label htmlFor="email" className="w-[235px] h-[22px] absolute justify-center text-[#172033] text-[13px] md:text-base font-semibold font-['Pretendard'] leading-[38px] top-[-10px] md:top-[-10px]">
            이메일
          </label>
          <div className="w-full h-12 md:h-14 mt-8">
            <input
              id="email"
              name="email"
              type="email"
              className="w-full h-full px-[18px] py-[15px] bg-white rounded-sm outline outline-[1px] md:outline-[0.50px] outline-[#d6dae5] text-[15px] font-medium font-['Pretendard'] leading-relaxed"
              placeholder="이메일 주소를 입력해주세요"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
        </div>

        {error && (
          <div className="text-sm text-red-600">
            {error}
          </div>
        )}

        {success && (
          <div className="text-sm text-green-600">
            비밀번호 재설정 링크가 이메일로 전송되었습니다.
          </div>
        )}

        <div className="flex flex-col space-y-4 mt-auto">
          <button
            type="submit"
            className={`w-full h-[52px] md:h-16 rounded-sm ${
              email.trim() 
                ? 'bg-[#155acb]' 
                : 'bg-gray-400'
            } disabled:bg-gray-400 flex items-center justify-center`}
            disabled={loading || !email.trim()}
          >
            <span className="text-white text-base font-bold font-['Pretendard'] leading-[38px]">
              {loading ? '전송 중...' : '비밀번호 재설정 링크 전송'}
            </span>
          </button>

          <button
            type="button"
            onClick={() => navigate('/signin')}
            className="text-[#2e97ee] text-[13px] md:text-base font-medium font-['Pretendard'] underline leading-relaxed"
          >
            로그인으로 돌아가기
          </button>
        </div>
      </div>
    </form>
  );
};

export default ResetPasswordForm; 